<template>
  <v-card flat rounded class="my-2">
    <v-card-text>
      <h2 class="secondary--text mb-4">Contractor Details</h2>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" md="2">
            <v-select
              :value="localValue.title"
              @input="updateField('title', $event)"
              :items="titles"
              label="Title"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :value="localValue.forename"
              @input="updateField('forename', $event)"
              label="First Name"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :value="localValue.middlename"
              @input="updateField('middlename', $event)"
              label="Middle Name"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              :value="localValue.surname"
              @input="updateField('surname', $event)"
              label="Last Name *"
              outlined
              dense
              :rules="[v => !!v || 'Last name is required']"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="localValue.companyName"
              @input="updateField('companyName', $event)"
              label="Company Name"
              outlined
              dense
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="localValue.email"
              @input="updateField('email', $event)"
              label="Email *"
              outlined
              dense
              :rules="emailRules"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              :value="localValue.mobilePhone"
              @input="updateField('mobilePhone', $event)"
              label="Mobile Phone *"
              outlined
              dense
              :rules="phoneRules"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              :value="localValue.commissionFee"
              @input="updateField('commissionFee', parseFloat($event) || 0)"
              label="Commission Fee (%)"
              outlined
              dense
              type="number"
              min="0"
              max="100"
              :rules="commissionRules"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              :value="localValue.contractorTypeId"
              @input="updateField('contractorTypeId', $event)"
              :items="contractorTypes"
              item-text="Name"
              item-value="OID"
              label="Contractor Type *"
              outlined
              dense
              :loading="contractorTypesLoading"
              :rules="[v => !!v || 'Contractor type is required']"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea
              :value="localValue.additionalInfo"
              @input="updateField('additionalInfo', $event)"
              label="Additional Information"
              outlined
              dense
              rows="3"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn
        color="primary"
        :disabled="!canProceed || loading"
        :loading="loading"
        @click="handleNext"
      >
        Next
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ContractorDetailsStep",
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      titles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Other"],
      emailRules: [
        v => !!v || "Email is required",
        v => /.+@.+\..+/.test(v) || "Email must be valid"
      ],
      phoneRules: [
        v => !!v || "Mobile phone is required",
        v => /^[\d\s+()-]+$/.test(v) || "Phone number must be valid"
      ],
      commissionRules: [
        v => v !== "" && v !== null && v !== undefined || "Commission fee is required",
        v => v >= 0 && v <= 100 || "Commission fee must be between 0 and 100"
      ]
    };
  },
  computed: {
    canProceed() {
      return this.valid;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    contractorTypes() {
      return this.$store.getters["ContractorsManagement/contractorTypes"];
    },
    contractorTypesLoading() {
      return this.$store.getters["ContractorsManagement/contractorTypesLoading"];
    }
  },
  methods: {
    updateField(field, value) {
      const updatedValue = { ...this.localValue, [field]: value };
      this.$emit("input", updatedValue);
    },
    handleNext() {
      if (this.$refs.form.validate()) {
        this.$emit("next");
      }
    }
  }
};
</script>